import React from 'react';
import type { BoletoInstructionsProps } from '../types/boleto-payment.types';

const BoletoInstructions: React.FC<BoletoInstructionsProps> = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold text-text-primary dark:text-gray-100 mb-3">
        Instruções para Pagamento:
      </h3>
      <ol className="list-decimal list-inside text-text-secondary dark:text-gray-300 space-y-2 text-sm">
        <li>Você pode pagar o boleto em qualquer banco, casa lotérica, ou através do seu internet banking.</li>
        <li>Utilize o código de barras (disponível no PDF) ou a linha digitável acima.</li>
        <li>O pagamento pode levar <strong>até 3 dias úteis</strong> para ser compensado.</li>
        <li>Após a compensação, seu pedido será processado e você receberá uma confirmação por e-mail.</li>
      </ol>
    </div>
  );
};

export default BoletoInstructions; 